import { useEffect, useState } from "react";
import useFetch from "@entrilia/shared/hooks/useFetch";
import { logError } from "@entrilia/shared/logging";
import biApi from "../../../../../api/biApi";
import type { SmartViewArtifactAgentMode } from "../../../../../api/types/smartViewArtifactsTypes";

interface ArtifactAgentModeState {
  agentMode: SmartViewArtifactAgentMode;
  setAgentMode: (mode: SmartViewArtifactAgentMode) => void;
  isThoroughAvailable: boolean;
}

const useArtifactAgentMode = (): ArtifactAgentModeState => {
  const [agentMode, setAgentMode] = useState<SmartViewArtifactAgentMode>("Quick");
  const [agentModes, agentModesError] = useFetch(biApi.smartViewArtifacts.getAgentModes);

  useEffect(() => {
    if (agentModesError) {
      logError(agentModesError, "[useArtifactAgentMode] getAgentModes");
    }
  }, [agentModesError]);

  return { agentMode, setAgentMode, isThoroughAvailable: agentModes?.includes("Thorough") ?? false };
};

export default useArtifactAgentMode;
